import { useParams } from 'react-router';

const useRecruitmentId = () => {
    const { assessmentId } = useParams();

    if (!assessmentId) {
        throw new Error(
            'useRecruitmentId can only be used on supported route e.g. /:companyId/assessments/:assessmentId/candidates-overview',
        );
    }

    return assessmentId;
};

export default useRecruitmentId;
